import { useState, useEffect } from 'react';

export default function useDOMById(id) {
  const [dom, setDom] = useState();

  useEffect(() => {
    setDom(document.getElementById(id));
    return () => {
      return null;
    };
  }, []);

  return dom;
}
